module.exports = __webpack_public_path__ + "img/星链订货平台banner.42d0373c.png";